import "./App.css";
import { Carousel } from "./components/Carousel/Carousel";
import { Footer } from "./components/Footer/Footer";
import { Navbar } from "./components/Navbar/Navbar";
import { Preguntas } from "./components/Preguntas/Preguntas";
import { Productos } from "./components/Productos/Productos";
import { Quienessomos } from "./components/Quienessomos/Quienessomos";
import { Ubicacion } from "./components/Ubicacion/Ubicacion";

function App() {
  return (
    <>
      <Navbar />
      <Carousel />
      <Quienessomos />
      <Productos />
      <Ubicacion />
      <Preguntas />
      <Footer />
    </>
  );
}

export default App;
